<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <!-- <h1>我的优惠券</h1> -->
            <div :class="[{'bb_bmHeadF':coupon_type==1},'bb_bmHead']" @click="switchCouponType(1)">
              自用券
              <div class="bb_bmHead_line" v-show="coupon_type==1"></div>
            </div>
            <div :class="[{'bb_bmHeadF':coupon_type==2},'bb_bmHead']" @click="switchCouponType(2)">
              邀约券
              <div class="bb_bmHead_line" v-show="coupon_type==2"></div>
            </div>
          </div>
          <div class="header__fixed__right">
            <a @click="toCouponRules()" class="coupons"></a>
          </div>
        </div>
      </div>
    </div>

    <!--
    优惠券类型区分：
      consum_limit  1卖卡  2预约  3全部
      coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
      type 1自用  2邀约
      status 1 正常 2已使用 3已作废 4已过期 5已赠送
     -->
    <div class="bb_coupon" v-show="is_loaded">
      <div v-if="coupon_list.length>0" class="bb_coupon_item" v-for="(item,index) in coupon_list" @click="bb_couponClick(item)">
        <div class="bb_coupon_item_info" :style="item.type==1?'background-image: url('+coupon_zy_bg+')':'background-image: url('+coupon_yy_bg+')'">
          <!-- 金额 -->
          <div v-if="item.info.coupon_type==1 || item.info.coupon_type==3" :class="[{'bb_coupon_item_info_leftlarge':JSON.stringify(item.info.amount).length>=3},'bb_coupon_item_info_left']">
            <label>¥</label>{{item.info.amount}}
            <div v-show="item.info.coupon_type==3" class="bb_coupon_item_info_left_diccounn">满{{item.info.full}}可用</div>
          </div>
          <!-- 折扣 -->
          <div v-else-if="item.info.coupon_type==2" :class="[{'bb_coupon_item_info_leftlarge':JSON.stringify(item.info.amount).length>=3},'bb_coupon_item_info_left']">
            {{(item.info.discount)*10}}&nbsp;&nbsp;<span class="bb_coupon_item_info_left_dic">折&nbsp;&nbsp;&nbsp;</span>
          </div>
          <!-- 抵用 -->
          <div v-else :class="[{'bb_coupon_item_info_leftlarge':JSON.stringify(item.info.amount).length>=3},'bb_coupon_item_info_left']">
            <!-- <label>¥</label>{{item.info.amount}} -->
            <div class="bb_coupon_item_info_left_dis">1次权益</div>
          </div>
          <!--  -->
          <div class="bb_coupon_item_info_right">
            <div class="bb_coupon_item_info_right_info">
              <!-- 券名称 -->
              <div class="bb_coupon_item_info_right_info_name">{{item.info.name}}</div>
              <!-- 有效期 -->
              <div class="bb_coupon_item_info_right_info_time" :style="item.type==1?'color: #8F8C98':'color: #A7B9DE'">有效期至{{(item.end_date).replace(/-/g,".")}}</div>
            </div>
            <!-- 自用、正常 -->
            <div v-if="item.type==1 && item.status ==1" class="bb_coupon_item_info_right_btn" :style="item.type==1?'color: #444054;':'color: #576B95;'">
              立即<br />使用
              <img :src="coupon_arrow" />
            </div>
            <!-- 自用、已使用 -->
            <img v-else-if="item.type==1 && item.status ==2" class="bb_coupon_item_info_right_isusered" src="../../assets/images/base/alerady_user.png" />
            <!-- 自用、已作废 -->
            <img v-else-if="item.type==1 && item.status ==3" class="bb_coupon_item_info_right_isusered" src="../../assets/images/base/alerady_cancel.png" />
            <!-- 自用、已过期 -->
            <img v-else-if="item.type==1 && item.status ==4" class="bb_coupon_item_info_right_isusered" src="../../assets/images/base/alerady_timeout.png" />
            <!-- 自用、已赠送 -->
            <img v-else-if="item.type==1 && item.status ==5" class="bb_coupon_item_info_right_isusered" src="../../assets/images/base/alerady_sell.png" />
            <!-- 邀约、正常、分享 -->
            <div v-else-if="item.type==2 && item.status ==1" class="bb_coupon_item_info_right_btn" :style="item.type==1?'color: #444054;':'color: #576B95;'">
              赠送<br />好友
              <img :src="coupon_arrow" />
            </div>
            <!-- <div v-else-if="item.type==2 && item.status ==1 && item.info.consum_limit==2" class="bb_coupon_item_info_right_btn" :style="item.type==1?'color: #444054;':'color: #576B95;'">
              立即<br />使用
              <img :src="coupon_arrow" />
            </div>
            <div v-else-if="item.type==2 && item.status ==1 && item.info.consum_limit==3" class="bb_coupon_item_info_right_btn" :style="item.type==1?'color: #444054;':'color: #576B95;'">
              立即<br />使用
              <img :src="coupon_arrow" />
            </div> -->
            <!-- 邀约、已使用 -->
            <img v-else-if="item.type==2 && item.status ==2" class="bb_coupon_item_info_right_isusered" src="../../assets/images/base/alerady_user.png" />
            <!-- 邀约、已作废 -->
            <img v-else-if="item.type==2 && item.status ==3" class="bb_coupon_item_info_right_isusered" src="../../assets/images/base/alerady_cancel.png" />
            <!-- 邀约、已过期 -->
            <img v-else-if="item.type==2 && item.status ==4" class="bb_coupon_item_info_right_isusered" src="../../assets/images/base/alerady_timeout.png" />
            <!-- 邀约、已赠送 -->
            <img v-else-if="item.type==2 && item.status ==5" class="bb_coupon_item_info_right_isusered" src="../../assets/images/base/alerady_sell.png" />
            <!-- 其他 -->
            <img v-else class="bb_coupon_item_info_right_isusered" src="../../assets/images/base/alerady_cancel.png" />
            <div class="clearboth"></div>
          </div>
          <div class="clearboth"></div>
        </div>
        <!--
        优惠券类型区分：
          consum_limit  1卖卡  2预约  3全部
          coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
          type 1自用  2邀约
          status 1 正常 2已使用 3已作废 4已过期 5已赠送
         -->
        <!-- 自用、卖卡 -->
        <div class="bb_coupon_item_button" v-if="item.type==1 && item.info.consum_limit==1">仅用于开通斐燃会员,不可多张叠加使用</div>
        <!-- 自用、代金券 -->
        <div class="bb_coupon_item_button" v-else-if="item.type==1 && item.consum_limit==2 && item.info.coupon_type==4">用于抵扣预约五星酒店健身游泳服务</div>
        <div class="bb_coupon_item_button" v-else-if="item.type==1 && item.consum_limit==2 && item.info.coupon_type==3">用于折扣预约五星酒店健身游泳服务费用</div>
        <div class="bb_coupon_item_button" v-else-if="item.type==1 && item.consum_limit==2 && item.info.coupon_type==2">用于折扣预约五星酒店健身游泳服务费用</div>
        <div class="bb_coupon_item_button" v-else-if="item.type==1 && item.consum_limit==2 && item.info.coupon_type==1">用于抵扣预约五星酒店健身游泳服务费用</div>
        <!-- 自用、抵扣 -->

        <!-- 自用、代金券 -->
        <div class="bb_coupon_item_button" v-else-if="item.type==1 && item.consum_limit==3 && item.info.coupon_type==4">可用于抵扣预约健身游泳服务和购买会员卡</div>
        <div class="bb_coupon_item_button" v-else-if="item.type==1 && item.consum_limit==3 && item.info.coupon_type==3">可用于折扣预约健身游泳服务和购买会员卡费用</div>
        <div class="bb_coupon_item_button" v-else-if="item.type==1 && item.consum_limit==3 && item.info.coupon_type==2">可用于折扣预约健身游泳服务和购买会员卡费用</div>
        <div class="bb_coupon_item_button" v-else-if="item.type==1 && item.consum_limit==3 && item.info.coupon_type==1">可用于抵扣预约健身游泳服务和购买会员卡费用</div>
        <!-- 邀约 -->
        <div class="bb_coupon_item_button" v-else>好友购买斐燃会员卡时可抵扣使用</div>
        <!-- <div class="bb_coupon_item_button" v-if="item.info.type==1 && item.info.consum_limit==1">好友购买斐燃会员卡时可抵扣使用</div>
        <div class="bb_coupon_item_button" v-else-if="item.info.consum_limit==1 && ">仅用于开通斐燃会员,不可多张叠加使用</div>
        <div class="bb_coupon_item_button" v-else-if="item.info.consum_limit==2">用于抵扣预约五星酒店健身游泳服务费用</div>
        <div class="bb_coupon_item_button" v-else-if="item.info.consum_limit==3">可用于抵扣预约健身游泳服务和购买会员卡费用</div> -->

        <div class="bb_coupon_item_mask" v-if="item.status != 1"></div>
      </div>
      <div v-if="coupon_list.length==0" class="bb_coupon_empty">
        <img :src="coupon_empty" class="bb_coupon_empty_img" />
        <div class="bb_coupon_empty_tips">暂无优惠券哦～</div>
      </div>
    </div>
    <div class="bb_coupon_list_mask" @click="cancelcouponshare()" v-show="couponmask">
      <img src="../../assets/images/base/zhixiang.png" />
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        coupon_zy_bg: require('../../assets/images/base/coupon_ziyong_up.png'),
        coupon_yy_bg: require('../../assets/images/base/coupon_yaoyue_up.png'),
        coupon_arrow: require('../../assets/images/base/coupon_arrow_icon.png'),
        coupon_empty: require('../../assets/images/base/coupon_empty.png'),

        bb_coupon_list: [],
        is_loaded: false,
        couponmask:false,

        // 2.2版本
        coupon_type:1,
        coupon_self:[],//自用券数组
        coupon_invite:[],//邀约券数组
        coupon_list:[],//对应数组的优惠券
        /**
          优惠券类型区分：
            consum_limit  1卖卡  2预约  3全部
            coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
            type 1自用  2邀约
            status 1 正常 4已过期 3已作废 2已使用 5已赠送
        */
      }
    },
    created() {
      this.getJsAuth()
      this.couponmask=false
      this.is_loaded=false
      this.getMyCoupons()
    },
    watch: {},
    mounted() {},
    methods: {
      getJsAuth() {
        // getJsAuth
        let that = this;
        var param = {
          url: encodeURIComponent(window.location.href)
        }
        var qs = require('qs');
        let url = this.api.userApi.getJsAuth
        this.axios.post(url, qs.stringify(param), )
        .then((res) => {
          // // // console.log(res)
          wx.config({
            debug: false,
            appId: res.data.appid, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.signature,
            jsApiList: [
              'getLocation',
              'updateAppMessageShareData', //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
              'updateTimelineShareData', //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
              'onMenuShareTimeline', //分享到朋友圈 老接口
              'onMenuShareAppMessage', //分享给盆友 老接口
            ]
          });
          wx.ready(function() {

          });
        }).catch((error) => {
          console.warn(error)
          that.$toast('error');
          that.$router.go(-1)
        })
      },
      getMyCoupons() {
        var $this = this
        // 重置优惠券数组数据
        $this.coupon_self=[]
        $this.coupon_invite=[]
        $this.coupon_list=[]
        let param = {
          token: localStorage.getItem("token"),
          page: 1,
          offset: 20000,
          type: 0,
          consum_rule: 0
        }
        $this.$loading('正在加载');
        // getCouponList
        var qs = require('qs');
        let url = this.api.userApi.getCouponList
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.code == 0) {
            // new
            // coupon_self:[],//自用券数组
            // coupon_invite:[],//邀约券数组
            // coupon_list:[],//对应数组的优惠券
            if(result.data && result.data.coupons && result.data.coupons.data && result.data.coupons.data.length>0){
              for (var i = 0; i < result.data.coupons.data.length; i++) {
                // result.data.coupons.data[i]
                // type 1自用  2邀约
                if(result.data.coupons.data[i].type==1){
                  $this.coupon_self.push(result.data.coupons.data[i])
                }else{
                  $this.coupon_invite.push(result.data.coupons.data[i])
                }
              }
            }else{
              $this.coupon_self=[]
              $this.coupon_invite=[]
              $this.coupon_list=[]
            }
            if($this.coupon_type==1){
              $this.coupon_list=$this.coupon_self
            }else{
              $this.coupon_list=$this.coupon_invite
            }
            // console.log($this.coupon_self)
            // console.log($this.coupon_invite)
            // console.log($this.coupon_list)

            // old
            // $this.bb_coupon_list = result.data.coupons.data
            setTimeout(function() {
              $this.$loading.close()
              $this.is_loaded = true
            }, 500)
          } else {
            $this.is_loaded = true
            $this.$loading.close()
          }
        }).catch((error) => {
          console.warn(error)
          $this.is_loaded = true
          $this.$loading.close()
        })
      },
      // 切换优惠券类型
      switchCouponType(item){
        this.coupon_type=item
        if(item==1){
          this.coupon_list=this.coupon_self
        }else{
          this.coupon_list=this.coupon_invite
        }
      },




      bb_couponClick(item) {
        // console.log(item)
        /**
          优惠券类型区分：
            consum_limit  1卖卡  2预约  3全部
            coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
            type 1自用  2邀约
            status 1 正常 4已过期 3已作废 2已使用 5已赠送
        */
        if(item.status == 1 && item.type==1 && item.consum_limit==1){
          // 买卡
          this.$router.push({
            name: 'vip'
          })
        }else if(item.status == 1 && item.type==1 && item.consum_limit==2){
          // 预约
          this.$router.push({
            name: 'reserve'
          })
        }else if(item.status == 1 && item.type==1 && item.consum_limit==3){
          // 预约
          this.$router.push({
            name: 'reserve'
          })
        }else if(item.status == 1 && item.type==2){
          // 邀请
          let that = this
          const u = navigator.userAgent;
          const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          if (isiOS) {
            wx.updateAppMessageShareData({
              title: '送您'+item.info.amount+'元代金券', // 分享标题
              desc: '成为斐燃会员，全国精选五星级奢华酒店健身等您来约！', //分享描述
              link: encodeURI((window.location.href).split('/mycoupon')[0])+'/sharecoupon?sharecode='+item.share_code, // 分享链接
              imgUrl: 'http://img.unionfit.cn/coupon_share.png', // 分享图标
              success(res) {
                // console.log(res)
                // alert(JSON.stringify(res))
              },
              fail(res){
                // console.log('分享给朋友 失败')
              }
            });
            wx.updateTimelineShareData({
              title: '送您'+item.info.amount+'元代金券', // 分享标题
              link: encodeURI((window.location.href).split('/mycoupon')[0])+'/sharecoupon?sharecode='+item.share_code, // 分享链接
              imgUrl: 'http://img.unionfit.cn/coupon_share.png', // 分享图标
              success(res) {
                // console.log(res)
                // alert(JSON.stringify(res))
              },
              fail(res){
                // console.log('分享给朋友圈 失败')
              }
            });
          } else {
            wx.onMenuShareAppMessage({
              title: '送您'+item.info.amount+'元代金券', // 分享标题
              desc: '成为斐燃会员，全国精选五星级奢华酒店健身等您来约！', //分享描述
              link: encodeURI((window.location.href).split('/mycoupon')[0])+'/sharecoupon?sharecode='+item.share_code, // 分享链接
              imgUrl: 'http://img.unionfit.cn/coupon_share.png', // 分享图标
              success(res) {
                // console.log(res)
                // alert(JSON.stringify(res))
              },
              fail(res){
                // console.log('分享给朋友 失败')
              }
            });
            wx.onMenuShareTimeline({
              title: '送您'+item.info.amount+'元代金券', // 分享标题
              link: encodeURI((window.location.href).split('/mycoupon')[0])+'/sharecoupon?sharecode='+item.share_code, // 分享链接
              imgUrl: 'http://img.unionfit.cn/coupon_share.png', // 分享图标
              success(res) {
                // console.log(res)
                // alert(JSON.stringify(res))
              },
              fail(res){
                // console.log('分享给朋友圈 失败')
              }
            });
          }
          setTimeout(function(){
            that.couponmask=true
          },300)
        }
      },
      cancelcouponshare(){
        this.couponmask=false
      },
      toCouponRules(){
        this.$router.push({
          name:'couponrule'
        })
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;

  .header__fixed__center {
    .bb_bmHead {
      width: 50%;
      float: left;
      height: 90*@vm_base;
      font-size: 28*@vm_base;
      font-weight: 400;
      color: rgba(180, 179, 187, 1);
      line-height: 90*@vm_base;
      text-align: center;
      position: relative;

      .bb_bmHead_line {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 39*@vm_base;
        height: 10*@vm_base;
        background: rgba(68, 64, 84, 1);
        border-radius: 25%;
        margin-left: calc(50% - 19.5*@vm_base);
      }
    }

    .bb_bmHeadF {
      font-weight: 600;
      color: rgba(68, 64, 84, 1);
    }
  }


  .bb_coupon{
    width: 100%;
    padding: 0 32*@vm_base 60*@vm_base 32*@vm_base;
    .bb_coupon_item{
      width: 100%;
      border-radius: 12*@vm_base;
      margin-top: 40*@vm_base;
      position: relative;
      .bb_coupon_item_info{
        width: 100%;
        height: 216*@vm_base;
        background-repeat: no-repeat;
        background-size: 100% 216*@vm_base;
        position: relative;
        .bb_coupon_item_info_left{
          width: calc(31.8% - 32*@vm_base);
          float: left;
          height: 100*@vm_base;
          line-height: 100*@vm_base;

          // padding: 0 32*@vm_base;
          margin: 0 0 0 32*@vm_base;
          margin-top: 57*@vm_base;
          text-align: center;
          font-size: 100*@vm_base;
          color: #FFFFFF;
          font-weight: 600;
          border-right: 1*@vm_base solid #7C7987;
          position: relative;
          // border: 1px solid red;
          label{
            position: absolute;
            top: 0;
            left: 0;
            height: 100*@vm_base;
            line-height: 36*@vm_base;
            margin-left: 8*@vm_base;
            margin-top: 10*@vm_base;
            font-size: 36*@vm_base;
          }
          .bb_coupon_item_info_left_dic{
            position: absolute;
            bottom: 0;
            right: 0;
            // height: 100*@vm_base;
            line-height: 36*@vm_base;
            margin-right: 8*@vm_base;
            margin-bottom: 10*@vm_base;
            font-size: 36*@vm_base;
            vertical-align: bottom;
          }
          .bb_coupon_item_info_left_dis{
            // display: inline-block;
            line-height: 100*@vm_base;
            // line-height: 1;
            font-size: 40*@vm_base;
            font-weight: normal;
            // border: 1px solid red;
          }
          .bb_coupon_item_info_left_diccounn{
            font-size: 24*@vm_base;
            font-weight: normal;
            text-align: center;
            line-height: 1;
          }
        }
        .bb_coupon_item_info_leftlarge{
          font-size: 60*@vm_base;
          label{
            margin-top: 25*@vm_base;
          }
        }
        .bb_coupon_item_info_right{
          width: calc(68.2% - 1*@vm_base);
          float: left;
          height: 100*@vm_base;
          margin-top: 57*@vm_base;
          padding: 0 39*@vm_base 0 28*@vm_base;
          // border: 1px solid red;
          .bb_coupon_item_info_right_info{
            width: calc(100% - 120*@vm_base);
            height: 100*@vm_base;
            float: left;
            .bb_coupon_item_info_right_info_name{
              width: 100%;
              height: 50*@vm_base;
              line-height: 50*@vm_base;
              color: #FFFFFF;
              font-size: 32*@vm_base;
            }
            .bb_coupon_item_info_right_info_time{
              width: 100%;
              height: 50*@vm_base;
              line-height: 50*@vm_base;

              font-size: 24*@vm_base;
            }
          }
          .bb_coupon_item_info_right_btn{
            width: 120*@vm_base;
            height: 120*@vm_base;
            float: left;
            background-color: #FFFFFF;
            border-radius: 50%;
            margin-top: -10*@vm_base;
            display: flex;
            align-items: center;
            justify-content: center;

            font-size: 28*@vm_base;
            font-weight: bold;
            position: relative;
            img{
              width: 25*@vm_base;
              position: absolute;
              top: 0;
              right: 0;
              z-index: 1;
              margin-top: 36*@vm_base;
            }
          }
          .bb_coupon_item_info_right_isusered{
            width: 120*@vm_base;
            // height: 120*@vm_base;
            float: left;
            border-radius: 50%;
            margin-top: -10*@vm_base;
          }
        }
      }
      .bb_coupon_item_button{
        width:100%;
        padding: 0 32*@vm_base;
        height:72*@vm_base;
        background:rgba(255,255,255,1);
        border-radius: 0 0 12*@vm_base 12*@vm_base;
        box-shadow:0px 10*@vm_base 20*@vm_base 0px rgba(238,238,238,1);
        display: flex;
        align-items: center;
        font-size: 24*@vm_base;
        font-weight: 500;
        color:rgba(143,140,152,1);
      }
      .bb_coupon_item_buttonUnuse{ }
      .bb_coupon_item_mask{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 282*@vm_base;
        z-index: 9;
        background:rgba(255,255,255,1);
        box-shadow:0px 10px 20px 0px rgba(238,238,238,1);
        opacity:0.38;
      }
      .bb_coupon_item_buttona::after{
        background:rgba(255,255,255,0.6);
      }
    }
    .bb_coupon_empty{
      width: 100%;
      border-radius: 12*@vm_base;
      .bb_coupon_empty_img{
        width: 419*@vm_base;
        margin: 0 auto;
        margin-top: 160*@vm_base;
      }
      .bb_coupon_empty_tips{
        width: 100%;
        text-align: center;
        color: #333333;
        font-size: 28*@vm_base;
        margin-top: 60*@vm_base;
      }
    }
  }
  .bb_coupon_list_mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background:rgba(0,0,0,0.6);
    z-index: 100;
    img{
      width: 361*@vm_base;
      float: right;
      margin-right: 60*@vm_base;
    }
  }
  .bb_coupon_reserve{
    height: calc(100vh - 90*@vm_base);
    overflow: hidden;
    overflow-y: auto;
    .bb_coupon_reserve_unselect{
      width: 36*@vm_base;
      height: 36*@vm_base;
      float: right;
      margin-top: -18*@vm_base;
      border: 1px solid #FFFFFF;
      border-radius: 50%;
    }
    .bb_coupon_reserve_selected{
      width: 36*@vm_base;
      height: 36*@vm_base;
      float: right;
      margin-top: -18*@vm_base;
      border-radius: 50%;
      background: url(../../assets/images/base/coupon_choice_right.png);
      background-size: cover;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/coupon/mycoupon.vue